import { render, staticRenderFns } from "./BackIcon.vue?vue&type=template&id=14b380bb&scoped=true"
import script from "./BackIcon.vue?vue&type=script&lang=js"
export * from "./BackIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b380bb",
  null
  
)

export default component.exports